import React, { Component } from 'react';

class DonutGraph extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    this.drawDonutGraph();
  }

  componentDidUpdate() {
    this.drawDonutGraph();
  }

  drawDonutGraph() {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const { data, colors, width, height ,textColor} = this.props;
  
    canvas.width = width; // Set canvas width
    canvas.height = height; // Set canvas height
  
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) - 10;
    const total = data.reduce((acc, value) => acc + value, 0);
  
    let startAngle = -Math.PI / 2;
    let endAngle = 0;
  
    for (let i = 0; i < data.length; i++) {
      endAngle = startAngle + (data[i] / total) * 2 * Math.PI;
  
      // Draw donut segment
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.closePath();
      ctx.fillStyle = colors[i];
      ctx.fill();
      startAngle = endAngle;
    }
  
    // Inner circle (to make a donut shape)
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius / 2, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fillStyle = 'white'; 
    ctx.fill();

    // Draw number in the middle
    ctx.fillStyle = textColor;
    ctx.font = 'bold 25px Quicksand, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(total.toString(), centerX, centerY);

  }
  
  render() {
    return <canvas ref={this.canvasRef} />;
  }
}

export default DonutGraph;
